import React from 'react'
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import CustomInput from '../../Utility/Components/CustomInput'
import CustomButton from './CustomButton';


function OrganisationFilterContent(props) {
    const { userCredentials, organizationModalfunction, handleUserSearchBar ,orgName,clearSearchValue, totalDatasetCount} = props;
    let version = userCredentials?.user_details?.version
    let roleName = userCredentials?.user_details?.user_type

    return (
        <>
            <div className="">
            <div className='total_organization'>Total Organization: {totalDatasetCount}</div>
                {roleName == "app_admin" ?
                    <div className="rightboxes">
                        {/* <button type="button" className="useraddbtn" onClick={organizationModalfunction}>Add</button> */}
                        <CustomButton
                                onClick={organizationModalfunction}
                                className="customButtonClass"
                                children="Add"
                            />

                    </div> : null}
                <div className="pageinnersearch">
                    <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                    <CustomInput
                        parentClassName="comment_input_field"
                        name="srchBox"
                        type="text"
                        placeholder="Search a organization"
                        onChange={(e) => handleUserSearchBar(e)}
                        value={orgName}
                    />
                    {
                       orgName != "" ?
                            < button type="button" className="btn btn-link dropclosebtn" onClick={clearSearchValue}>
                                <img src={require('../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                            </button>
                            : null}
                </div>
            </div>
        </>
    )
}
const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials
    };
}

export default withRouter(connect(mapStateToProps, {})
    (withTranslation()(OrganisationFilterContent)));
